import * as React from 'react';
type Props = {
  className?: string;
};
export function SmokedSalmon({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-SmokedSalmon"
      className={className}
    >
      <path
        d="M13.0234 5.76367C17.8484 13.8279 26.0663 20.61 35.9251 19.1"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M30.6544 46.1482C26.006 44.1127 23.6294 38.6772 20.3151 35.0696C16.8526 31.3007 13.361 28.0002 10.2914 23.8118C8.78211 21.7526 6.15573 19.4762 6.25261 16.6133C6.32661 14.4284 7.94948 12.1389 9.18673 10.4498C11.5202 7.26356 14.5155 3.7485 18.4767 5.43931C22.562 7.18306 26.1694 10.3623 29.4995 13.2624C33.0226 16.3304 36.4595 19.5908 39.4944 23.1796C40.9057 24.8486 42.2561 26.6626 42.865 28.8422C43.7811 32.1216 42.2629 35.1248 40.382 37.8047C39.1114 39.6152 33.3341 46.6747 30.6544 46.1482Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M9.82849 10.2472C12.6231 12.7374 17.9795 18.2813 20.2772 27.2086C21.1911 30.7597 21.4011 33.9911 21.3461 36.5879"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M26.2376 42.726C25.7158 38.4168 21.8996 25.8188 27.0689 24.0443C30.5125 22.8622 37.5864 24.8434 41.0906 25.0714"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M37.2685 37.471C37.991 35.7939 37.5196 33.979 36.2158 33.4172C34.912 32.8556 33.2693 33.7599 32.5468 35.4369C31.8243 37.114 32.2957 38.9289 33.5995 39.4906C34.9033 40.0522 36.546 39.148 37.2685 37.471Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M30.5013 46.0793C29.9795 41.7701 26.399 30.6783 31.5681 28.9038C35.0118 27.7217 39.5577 29.2667 43.0511 29.6127"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
